//src/pages/admin/AdminLogin.js
import React, { useState } from "react";
import { adminLogin } from "../../api/admin/adminApi";
import { useNavigate } from "react-router-dom";
import { FaUserAlt } from "react-icons/fa";
import { MdLock } from "react-icons/md";

const AdminLogin = ({ onLogin }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { token } = await adminLogin(username, password);
      localStorage.setItem("adminToken", token); // Store token for subsequent requests
      alert("Logged In Successfully!");
      navigate("/admin/secret-portal-entry/admin-dashboard");
    } catch (err) {
      setError("Invalid username or password");
    }
  };

  return (
    <div className="login-container flex flex-col items-center  justify-center  w-full ">
      <h2 className="pt-5 mb-5  text-3xl">Admin Login</h2>

      <div className="lg:w-1/3 md:w-8/12 w-11/12 mx-auto inner-container border-2 rounded-3xl shadow-lg shadow-slate-500 px-12 py-20">
        {error && <p className="error">{error}</p>}
        <form onSubmit={handleSubmit}>
          <div className="mb-10">
            <h5 className="text-left">Enter Username</h5>
            <div className="border-b-2 border-b-purple-400 flex justify-between items-end mt-2">
              <input
                className="w-full md:h-10 h-6 pr-2 text-xs md:text-base focus:outline-none"
                type="text"
                placeholder="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
              <FaUserAlt className="md:text-xl text-xl text-[#6C63FF] mb-1" />
            </div>
          </div>

          <div className="mb-5">
            <h5 className="text-left">Enter password</h5>
            <div className="border-b-2 border-b-purple-400 flex justify-between items-end mt-2">
            <input
              className="w-full md:h-10 h-6 pr-2 text-xs md:text-base focus:outline-none"
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <MdLock className="md:text-2xl text-xl text-[#6C63FF] mb-1" />
            </div>
          </div>

          <button
            type="submit"
            className="w-fit block mx-auto bg-[#6C63FF] rounded-lg h-10 text-white font-bold mt-12 px-20"
          >
            Login{" "}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
